// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608211002/js/" + chunkId + "." + {"44":"b45cf55c","225":"4cc708cf","481":"05e9b14e","486":"1f99cdd4","770":"188427f8"}[chunkId] + ".0.5247998431847866.chunk.js";
};